import './contact.component.scss'

import customSelect from 'custom-select'
import './../../styles/modules/plugins/custom-select.scss'


class FormHandler {
	constructor(formSelector) {
		this.forms = document.querySelectorAll(formSelector);

		this.forms.forEach((form) => {
			const inputFields = form.querySelectorAll('.contact-form__input input, .contact-form__input textarea')
			const phoneInput = form.querySelector('.contact-form__input_tel')
			const select = form.querySelector('select')

			this.init(form, inputFields, phoneInput, select)
		})
	}

	formatPhoneNumber(event) {
		const input = event.target
		const inputValue = input.value.replace(/\D/g, '')
		const areaCode = inputValue.substring(0, 3)
		const centralOfficeCode = inputValue.substring(3, 6)
		const lineNumber = inputValue.substring(6, 10)

		let formattedValue = ''

		if (inputValue.length > 6) {
			formattedValue = `(${areaCode}) ${centralOfficeCode}-${lineNumber}`
		} else if (inputValue.length > 3) {
			formattedValue = `(${areaCode}) ${centralOfficeCode}`
		} else if (inputValue.length > 0) {
			formattedValue = `(${areaCode}`
		}

		input.value = formattedValue
	}

	checkPhone(field) {
		if (field) {
			field.addEventListener('input', this.formatPhoneNumber)
		}
	}

	fieldBlur(field) {
		field.addEventListener('blur', () => {
			if (field.value == '') {
				field.classList.remove('js-filled')
				field.closest('.contact-form__input').classList.remove('js-focus')
			} else {
				field.classList.add('js-filled')
			}
		})
	}

	checkLenght(fields) {
		fields.forEach(field => {
			if (field.value != '') {
				field.classList.add('js-filled')
				field.closest('.contact-form__input').classList.add('js-focus')
			}
		})
	}

	fieldFocus(field) {
		field.addEventListener('focus', () => {
			field.closest('.contact-form__input').classList.add('js-focus')
		})
	}

	animFields(fields) {
		if (fields?.length > 0) {
			fields.forEach(field => this.fieldFocus(field))
			fields.forEach(field => this.fieldBlur(field))
		}
	}

	observer(form) {
		if (form) {
			const observerOptions = {
				attributes: true,
				childList: true,
			}

			const observerForm = new MutationObserver(mutationsList => {
				for (const mutation of mutationsList) {
					if (mutation.type === 'childList') {
						const inputFields = document.querySelectorAll('.contact-form__input input, .contact-form__input textarea')
						this.checkLenght(inputFields)
						this.animFields(inputFields)

						const phoneInput = document.querySelector('.contact-form__input_tel')
						this.checkPhone(phoneInput)

						const select = form.querySelector('select')
						this.select(select)

						const oldSelect = form.querySelector('.custom-select-container .custom-select-container')
						oldSelect.remove()
					}
				}
			})

			observerForm.observe(form, observerOptions)
		}
	}

	select(el) {
		if (el) {
			customSelect(el)
		}
	}

	init(form, inputFields, phoneInput, select) {
		this.checkPhone(phoneInput)
		this.animFields(inputFields)
		this.observer(form)
		this.select(select)
	}
}

window.addEventListener('DOMContentLoaded', () => {
	new FormHandler('.gravity-theme')
})
